import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SensorsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sensors"}/>
}
